import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  template: `
    <div class="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <h2 class="mb-3">Unauthorized</h2>
      <p class="mb-4">You do not have permission to access this page.</p>
      <button class="btn btn-danger d-flex align-items-center" (click)="signOut()">
        <span class="me-2">🚪</span>
        <span>Logout</span>
      </button>
    </div>
  `
})
export class UnauthorizedComponent {
  constructor(private authService: AuthService) {}
  async signOut() {
    await this.authService.signOut();
  }
}
